import { render, staticRenderFns } from "./AdminMatchForm.vue?vue&type=template&id=12e44a90&scoped=true"
import script from "./AdminMatchForm.vue?vue&type=script&lang=js"
export * from "./AdminMatchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e44a90",
  null
  
)

export default component.exports